/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabeljester3Inputs */



/**
* | output |
* | --- |
* | "The Jokester" |
*
* @param {Personalityarchetypelabeljester3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabeljester3 = /** @type {((inputs?: Personalityarchetypelabeljester3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabeljester3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Jokester")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Bromista")
	return /** @type {LocalizedString} */ ("Приколист")
});
export { personalityarchetypelabeljester3 as "personalityArchetypeLabelJester" }